import { Link } from "react-router-dom";

import dd from "../../assets/DD.png";

const MobileDropdown = ({
  title,
  isOpen,
  setIsOpen,
  items,
  handleLinkClick,
}) => {
  return (
    <div>
      <button
        className="flex items-center justify-between w-full text-black hover:text-black py-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <img
          src={dd}
          alt="Dropdown arrow"
          className={`h-1 w-2 transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`}
        />
      </button>
      {isOpen && (
        <div className="mt-2 space-y-1">
          {items.map((item) =>
            item.external ? (
              <a
                key={item.to}
                href={item.to}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
                className="block px-4 py-2 text-xs hover:bg-gray-100"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                onClick={handleLinkClick}
                className="block px-4 py-2 text-xs hover:bg-gray-100"
              >
                {item.label}
              </Link>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default MobileDropdown;
